module.exports = __webpack_public_path__ + "static/EstoreShopserve-2c0a54c183c522983dab9c873d92e5c3.svg";